import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { ListPreferenceResult, setListPreference } from "../../utils/list/utils/setListPreference";
import {
    PURCHASES_UNPAID_MODULE,
    UNPAID_COLUMN,
    UNPAID_COLUMN_CTI,
    UNPAID_COLUMN_TOURIST,
} from "../constant/purchasesReceiptConstant";

const subDomain = window.location.host.split('.')[0];
const unpaidColumns = (): Column[] => {
    if (subDomain === 'continents-insolites') return UNPAID_COLUMN_CTI;
    if (subDomain === 'tourist-forum') return UNPAID_COLUMN_TOURIST;
    return UNPAID_COLUMN;
};

export const setPurchasesReceiptUnpaidPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: PURCHASES_UNPAID_MODULE,
        default_columns: unpaidColumns(),
        default_order_by: '',
        default_order: 'asc',
    });
